import { isAxiosError } from 'axios';
export function clinicalAccessError(error: unknown, fallback: string): string {
  if (!isAxiosError(error) || error.response?.status !== 403) return fallback;
  const detail = error.response.data?.detail;
  if (typeof detail === 'string' && detail.startsWith('Missing required permission: ')) {
    return `Your practice role needs ${detail.slice('Missing required permission: '.length).replaceAll('_', ' ')} access. Ask your administrator to update your role in Roles and Users; administrative access alone does not grant clinical access.`;
  }
  return 'Clinical chart access was denied. Confirm active practice membership and explicit clinical permissions with your administrator.';
}
